import { render, staticRenderFns } from "./LatestReports.vue?vue&type=template&id=a3b0243a&scoped=true&"
import script from "./LatestReports.vue?vue&type=script&lang=js&"
export * from "./LatestReports.vue?vue&type=script&lang=js&"
import style0 from "./LatestReports.vue?vue&type=style&index=0&id=a3b0243a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b0243a",
  null
  
)

export default component.exports